<template>
    <gj-modal :visible.sync="modalVisible" size="full" :contentStyle="{ 'height': '100%', overflow: 'hidden' }">
        <template #header>
            <span>{{ content }}</span>
        </template>
        <template #content>
            <video controls style="width: 100%;height: 100%;">
                <source :src="url" type="video/mp4">
                您的浏览器不支持播放视频，请使用谷歌浏览器！
            </video>
        </template>
    </gj-modal>
</template>

<script>
import { modalMixIn } from "../../minxins";

export default {
    name: "gj-video-modal",
    mixins: [modalMixIn],
    props: {
        content: String,
        url: String
    },
}
</script>

<style lang="scss" scoped>
.gj-modal--full /deep/ .el-dialog {
    height: 100% !important;
    width: 1200px !important;
  }
</style>
